/* eslint-disable react/prop-types */ /* eslint-disable import/prefer-default-export */ /* eslint-disable no-unused-vars */ import React, {  useState,
  useContext,
  useEffect,
} from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Loading from '../../components/loading/Loading';
import Filter from './Filter';
import { CostCentersTable } from './CostCentersTable';
import FlashContext from '../../components/contexts/FlashContext';
import api from '../../service/axios/api';
import { TYPE_OPTIONS } from '../sales/util/constants/index';




export default function CostCenters() {
  const { t } = useTranslation();
  const { notifyError, notifySuccess } = useContext(FlashContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [itens, setItens] = useState(10);
  const [chipData, setChipData] = useState([]);

  const [name, setName] = useState('');
  const [code, setCode] = useState('');
 // const [type, setType] = useState('');
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    searchData();
  }, []);

  const handleCreate = async () => {
    if (name.trim().length === 0) {
      notifyError(t('costCenters.createDialog.errors.name'));
      return;
    }
    if (code.trim().length === 0) {
      notifyError(t('costCenters.createDialog.errors.code'));
      return;
    }
    
   /* if (type.trim().length === 0) {
      notifyError(t('costCenters.createDialog.errors.type'));
      return;
    } */
    setLoadingCreate(true);

    try {
      const res = await api.costCenter.create(name, code/* , type */);
      notifySuccess(res.data.message);
      setName('');
      setCode('');
      // setType('');
      setOpenDialog(false);
      searchData();
    } catch (error) {
      if (error.problems && error.problems.length > 0) {
        error.problems.forEach(err => {
          notifyError(err.msg);
        });
      } else {
        notifyError(error.message);
      }
    } finally {
      setLoadingCreate(false);
    }
  };

  const searchData = currentChips => {
    setLoading(true);

    const filtersToUse = currentChips || chipData;

    api.costCenter
      .getAll(filtersToUse, itens, page + 1)
      .then(res => {
        setTotal(res.data.total);
        setData(res.data.docs);
      })
      .catch(error => {
        notifyError(error.message);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    searchData();
  }, [page, itens]);

  return (
    <>
      <Loading open={loading} msg={t('costCenters.loading')} />
      <Grid>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'start' }}
        >
          <h3>{t('costCenters.title')}</h3>
        </Grid>

        <Filter
          setChipData={setChipData}
          chipData={chipData}
          find={searchData}
          setPage={setPage}
          setOpenDialog={setOpenDialog}
        />

        <CostCentersTable
          docs={data}
          page={page}
          setPage={setPage}
          itens={itens}
          setItens={setItens}
          total={total}
          searchData={searchData}
        />
      </Grid>
      <Dialog
        onClose={() => setOpenDialog(false)}
        open={openDialog}
        fullWidth
        maxWidth="sm"
      >
        <Loading
          open={loadingCreate}
          msg={t('costCenters.createDialog.loading')}
        />
        <DialogTitle id="simple-dialog-title">
          {t('costCenters.createDialog.title')}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            spacing={4}
            style={{
              justifyContent: 'center',
            }}
          >
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label={t('costCenters.filter.options.name')}
                variant="outlined"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} sm={8}>
              <TextField
                fullWidth
                label={t('costCenters.filter.options.code')}
                variant="outlined"
                value={code}
                onChange={e => setCode(e.target.value)}
              />
            </Grid>
            {/* <Grid item xs={12} sm={8}>
              <FormControl fullWidth variant="outlined">
                  <InputLabel>Tipo</InputLabel>
                  <Select
                    value={type}
                    onChange={e => setType(e.target.value)}
                    label="Tipo"
                  >
                    {TYPE_OPTIONS.map(opt => (
                      <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
            </Grid> */}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            style={{ height: 40 }}
            onClick={() => setOpenDialog(false)}
            variant="text"
            color="primary"
          >
            {t('costCenters.createDialog.buttons.cancel')}
          </Button>
          <Button
            style={{ height: 40 }}
            onClick={handleCreate}
            variant="contained"
            color="primary"
          >
            {t('costCenters.createDialog.buttons.create')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
